/* list.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./list.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef, useEffect, useRef } from 'react';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';

// Placing this const below the function breaks Compiled!
var styles = {
  root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkgrf3"
};
function _List(_ref, forwardedRef) {
  var children = _ref.children,
    xcss = _ref.xcss;
  var internalRef = useRef(null);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (internalRef.current) {
        Array.from(internalRef.current.children).forEach(function (child) {
          if (isValidChild(child)) {
            return;
          }

          // eslint-disable-next-line no-console
          console.error('List Composition Error\n\n', 'This element is not a semantically valid list item:\n\n', child, '\n\nThis is an accessibility issue and must be fixed.\n\n', 'This message will not be displayed in production.');
        });
      }
    }
  }, []);
  var ref = mergeRefs([internalRef, forwardedRef]);
  return /*#__PURE__*/React.createElement("div", {
    role: "list",
    ref: ref,
    className: ax([styles.root, xcss])
  }, children);
}

/**
 * __List__
 *
 * An [unordered list](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul) with visual styles removed,
 * for semantically grouping list items.
 */
export var List = /*#__PURE__*/forwardRef(_List);

/**
 * Returns true if the child is either:
 * - a list item
 * - one or more list items wrapped only in presentational elements
 */
function isValidChild(element) {
  /**
   * These elements are ignored by screen readers.
   */
  if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') {
    return true;
  }

  /**
   * Recursive case:
   * If this is a presentational element (no semantics) then it is valid
   * if all of its children are valid.
   *
   * This check is currently much stricter than it needs to be
   * (only allowing `div` and not allowing an explicit role).
   *
   * We can make it looser in the future if necessary.
   */
  if (element.tagName === 'DIV' && element.getAttribute('role') === null) {
    return Array.from(element.children).every(isValidChild);
  }
  return element.getAttribute('role') === 'listitem';
}